import React from "react";
import Notification from "../../../components/Notification/Notification";
import AttestedCertificatesTable from "../../../components/AttestedCertificatesTable/AttestedCertificatesTable";

const AttestedCertificates = () => {
  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3">
            Attested Certificates
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <Notification />
          </div>
        </div>
      </div>
      <div>
        <AttestedCertificatesTable />
      </div>
    </>
  );
};

export default AttestedCertificates;
